import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, PendingIcon, OKIcon, ErrorIcon } from "./styles";
import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import api from "../../services/api";
import moment from "moment";

const ProductUpdate = () => {
  var GTINsAtualizando = [];

  const [GTINs, setGTINs] = useState();
  const [atualizou, setAtualizou] = useState(false);

  // Percorre todas as chaves do localStorage
  for (var i = 0; i < localStorage.length; i++) {
    var chave = localStorage.key(i);

    // Verifica se a chave começa com "updateGTIN"
    if (chave.startsWith("updateGTIN")) {
      //Adiciona os valores de GTINs no array
      GTINsAtualizando.push(localStorage.getItem(chave));
    }
  }

  const dataGTINsAtualizando = encodeURIComponent(
    JSON.stringify(GTINsAtualizando)
  );

  /*
    // A URL acima vai me devolver um JSON tipo esse, com as ESLs com o GTIN que ele recebeu na URL:
    setGTINs([
      {
        GTIN: "0000000100011",
        productName: "Produto 1",
        materialCode: "Codigo 1",
        price: "99,00",
        rating: "3.8",
        ESLs: [
          {
            mac: "00:00:00:00:00:01",
            business_unit_code: "0",
            location: "Piracicaba/SP",
            size: "S",
            commission_status: "K",
            is_alive: true,
            sgln: "0SJDS1L1S1F1",
            actions: [
              {
                action: "update",
                price: "99,00",
                timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
              },
              {
                action: "update",
                price: "99,00",
                timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
              },
            ],
          },
          {
            mac: "00:00:00:00:00:02",
            business_unit_code: "0",
            location: "Piracicaba/SP",
            size: "S",
            commission_status: "K",
            is_alive: true,
            sgln: "0SJDS1L1S1F2",
            actions: [
              {
                action: "update",
                price: "99,00",
                timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
              },
              {
                action: "update",
                price: "99,00",
                timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
              },
            ],
          },
        ],
      },
      {
        GTIN: "7891000100011",
        productName: "Produto 2",
        materialCode: "Codigo 2",
        price: "20,00",
        rating: "4.5",
        ESLs: [
          {
            mac: "00:00:00:00:00:03",
            business_unit_code: "0",
            location: "São Carlos/SP",
            size: "M",
            commission_status: "K",
            is_alive: true,
            sgln: "1SJDS1L1S1F1",
            actions: [
              {
                action: "update",
                price: "20,00",
                timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
              },
              {
                action: "update",
                price: "20,00",
                timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
              },
            ],
          },
          {
            mac: "00:00:00:00:00:04",
            business_unit_code: "0",
            location: "São Carlos/SP",
            size: "S",
            commission_status: "K",
            is_alive: true,
            sgln: "1SJDS1L1S1F2",
            actions: [
              {
                action: "update",
                price: "20,00",
                timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
              },
              {
                action: "update",
                price: "20,00",
                timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
              },
            ],
          },
        ],
      },
    ]);
    */

  useEffect(() => {
    api.get(`/productUpdate`).then((response) => {
      setGTINs(response.data);

      const resultados = response.data.map((produto) => {
        const todasComissoesK = produto.esls.every(
          (esl) => esl.commission_status === "K"
        );
        const todasAtivas = produto.esls.every((esl) => esl.is_alive === true);
        return todasComissoesK && todasAtivas;
      });

      setAtualizou(resultados);
    });
  }, [dataGTINsAtualizando]);

  // Mostrar na tabela com a situação de atualização de cada uma
  // Entao no backend, a parte que ta implementada dentro do socket deve virar algo separa em uma URL, pois sera chamada novamente para ver qual o status de cada ESL
  // Essa URL deve ser chamada a cada 5 segundos, por exemplo, para atualizar o status de cada ESL

  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedRowsESLs, setExpandedRowsESLs] = useState([]);

  const toggleRow = (product_gtin) => {
    const newExpandedRows = [...expandedRows];
    const rowIndex = newExpandedRows.indexOf(product_gtin);

    if (rowIndex >= 0) {
      newExpandedRows.splice(rowIndex, 1);
    } else {
      newExpandedRows.push(product_gtin);
    }

    setExpandedRows(newExpandedRows);
  };

  const toggleRowESL = (mac) => {
    const newExpandedRowsESLs = [...expandedRowsESLs];
    const rowIndex = newExpandedRowsESLs.indexOf(mac);

    if (rowIndex >= 0) {
      newExpandedRowsESLs.splice(rowIndex, 1);
    } else {
      newExpandedRowsESLs.push(mac);
    }

    setExpandedRowsESLs(newExpandedRowsESLs);
  };
  return (
    <Container>
      <h3>Atualização de preço</h3>

      <MDBTable align="start" hover>
        <MDBTableHead>
          <tr>
            <th>GTIN</th>
            <th>Nome do Produto</th>
            <th>Código do Material</th>
            <th>Preço</th>
            <th>Avaliação</th>
            <th>Data/Hora</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {GTINs?.map((GTIN) => (
            <React.Fragment key={GTIN.GTIN}>
              <tr
                onClick={() => toggleRow(GTIN.GTIN)}
                style={{ cursor: "pointer" }}
              >
                <td>{GTIN.product_gtin}</td>
                <td>{GTIN.product_title}</td>
                <td>{GTIN.material_code}</td>
                <td>{GTIN.product_price}</td>
                <td>{GTIN.product_rating}</td>
                <td>
                  {moment.utc(GTIN.timestamp).format("HH:mm:ss - DD/MM/YYYY")}
                </td>
              </tr>
              {/*expandedRows.includes(GTIN.GTIN) && (
                <tr>
                  <td colSpan="5">
                    <MDBTable align="start" hover>
                      <MDBTableHead>
                        <tr>
                          <th>MAC</th>
                          <th>Loja</th>
                          <th>Cidade</th>
                          <th>Size</th>
                          <th>isAlive</th>
                          <th>SGLN</th>
                        </tr>
                      </MDBTableHead>
                      <MDBTableBody>
                        {GTIN.esls.map((esl) => (
                          <React.Fragment key={esl.mac}>
                            <tr
                              className="table-light"
                              onClick={() => toggleRowESL(esl.mac)}
                            >
                              <td>{esl.mac}</td>
                              <td>{esl.business_unit_code}</td>
                              <td>{esl.location}</td>
                              <td>{esl.size}</td>
                              <td>{esl.is_alive ? "Atualizou" : "Erro"}</td>
                              <td>
                                {esl.sgln &&
                                  "Seção:" +
                                    esl.sgln.slice(2, 4) +
                                    " - Prat:" +
                                    esl.sgln.slice(5, 6) +
                                    " - Nível:" +
                                    esl.sgln.slice(7, 8) +
                                    " - Slot:" +
                                    esl.sgln.slice(9, 10) +
                                    " - Face:" +
                                    esl.sgln.slice(11, 12)}
                              </td>
                            </tr>
                            {expandedRowsESLs.includes(esl.mac) && (
                              <tr>
                                <td colSpan="5">
                                  <MDBTable align="start">
                                    <MDBTableHead>
                                      <tr>
                                        <th>Ação</th>
                                        <th>Status</th>
                                        <th>Timestamp</th>
                                      </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                      {esl.actions.map((action) => (
                                        <tr key={action.action}>
                                          <td>{action.action}</td>
                                          <td>{action.status}</td>
                                          <td>{action.timestamp}</td>
                                        </tr>
                                      ))}
                                    </MDBTableBody>
                                  </MDBTable>
                                </td>
                              </tr>
                                      )}
                          </React.Fragment>
                        ))}
                      </MDBTableBody>
                    </MDBTable>
                  </td>
                </tr>
                                    )*/}
            </React.Fragment>
          ))}
        </MDBTableBody>
      </MDBTable>
    </Container>
  );
};

export default ProductUpdate;
